import { jwtDecode } from "jwt-decode";
    
export const sendEmailVerifyCode = () => async (dispatch) => {
    dispatch({ type: 'SEND_EMAIL_VERIFICATION_CODE_LOADING' });
    const token = JSON.parse(localStorage.getItem("token"));
    const decodedToken = jwtDecode(token);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/sendEmailVerifyCode`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: decodedToken.email,
          }),
        }
      );

      if (response.status === 200) {
        dispatch({ type: 'SEND_EMAIL_VERIFICATION_CODE_SUCCESS' });
      }
    } catch (error) {
        dispatch({ type: 'SEND_EMAIL_VERIFICATION_CODE_ERROR', payload: error });
    }
}

export const authenticatorAppClick = () => async(dispatch) => {
  dispatch({ type: 'AUTHENTICATOR_APP_CLICK_LOADING' });
  const token = JSON.parse(localStorage.getItem("token"));
  const decodedToken = jwtDecode(token);
  const userGuid = decodedToken?.userGuid;
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/auth/authenticate_user_live`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: decodedToken.email,
          userGuid: userGuid,
        }),
      }
    );
    const data = await response.json();
    if (response.status === 200) {
      dispatch({ type: 'AUTHENTICATOR_APP_CLICK_SUCCESS', payload: data });
    }
  } catch (error) {
    dispatch({ type: 'AUTHENTICATOR_APP_CLICK_ERROR', payload: error });
  }
}